// node端的配置
console.log("[-> config/index.js] process.env", process.env, process.env.BASE_URL);

const baseConfig = require('./base.bm.json');
const nodeConfig = Object.assign({}, window.NODE_CONFIG);

// 前端的配置
let config = {
  // 项目目录
  publicPath: baseConfig.publicPath,
  // 接口地址前缀
  serviceHost: baseConfig.serviceHost,
  // 路由认证
  auth: baseConfig.authConfig,
  // Editor
  editorConfig: baseConfig.editorConfig
  // failCode: baseConfig.failCode
};
// 合并Node端配置
config = Object.assign(config, nodeConfig);
console.log('[-> CONFIG]', config);
window.CONFIG = config;

export default config
